export default __webpack_public_path__ + "static/womanIpadImg-503ba8677963e8f85195bdac32a55654.webp";